export const SUPPORT_EMAIL = 'bc2801@hotmail.com';
export const SALES_MAILTO = `mailto:${SUPPORT_EMAIL}`;
export const FREE_PM_CHECKLISTS_URL = 'https://free-pm-checklists.netlify.app';

/** Public prices that match GET /api/billing/plans and POST /api/billing/checkout. */
export const PUBLIC_PLANS = [
  {
    name: 'Free',
    price: '$0',
    period: '',
    description: 'Up to 3 users and 100 work orders total',
    features: [
      'Up to 3 users',
      '100 work orders total',
      'Basic reporting',
      'Email support',
      'Work orders, inventory, and locations',
    ],
    cta: 'Get Started',
    highlighted: false,
  },
  {
    name: 'Pro',
    price: '$29',
    period: 'per month',
    description: 'Flat $29 per month for the company',
    features: [
      'Unlimited users',
      'Unlimited work orders',
      'Advanced reporting',
      'Priority email support',
      'Custom fields, CSV export, and API access',
    ],
    cta: 'Get Started',
    highlighted: true,
  },
  {
    name: 'Enterprise',
    price: 'Contact us',
    period: '',
    description: `Custom pricing. Email ${SUPPORT_EMAIL}. There is no self-serve Enterprise charge.`,
    features: [
      'Everything in Pro',
      'White-label branding',
      'SSO',
      'Dedicated support',
    ],
    cta: 'Contact Sales',
    highlighted: false,
  },
];

/**
 * The landing editor can store a period like "per user/month" or an Enterprise
 * dollar amount. Checkout does not charge per user or an Enterprise list price.
 */
export function displayPlan(plan) {
  const next = { ...plan };
  const name = String(next.name || '').toLowerCase();
  const known = PUBLIC_PLANS.find((item) => item.name.toLowerCase() === name);
  if (known) {
    next.price = known.price;
    next.period = known.period;
    next.description = known.description;
    next.features = known.features.slice();
    return next;
  }
  const price = String(next.price || '');
  let period = String(next.period || '');
  if (/per user/i.test(period)) period = 'per month';
  if (/forever/i.test(period)) period = '';
  next.period = period;
  next.description = String(next.description || '')
    .replace(/min\.?\s*\d+\s*users/gi, '')
    .replace(/per user/gi, 'for the company')
    .replace(/forever/gi, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/\s*·\s*$/g, '')
    .trim();
  if (name === 'enterprise' || /^custom$/i.test(price)) {
    next.price = 'Contact us';
    next.period = '';
    next.description = PUBLIC_PLANS[2].description;
  }
  if (name === 'pro' && /^\$99$/.test(price)) {
    next.price = '$29';
    next.period = 'per month';
    next.description = PUBLIC_PLANS[1].description;
  }
  return next;
}

export function isContactPlan(plan) {
  const price = String(plan?.price || '');
  return price === 'Contact us' || String(plan?.name || '').toLowerCase() === 'enterprise';
}

const UNVERIFIED_CLAIM = /soc\s*2|\d{1,3}\s*%|trusted by|\d[\d,]*\s*\+|4\.\d\s*\/\s*5|bank-level/i;

/** Replace stored copy that claims customers, ratings, or certifications. */
export function replaceUnverified(text, fallback) {
  if (!text || UNVERIFIED_CLAIM.test(String(text))) return fallback;
  return text;
}

export function publicBadge(badge) {
  return replaceUnverified(badge, 'Work orders, preventive maintenance, and inventory');
}

export function assigneeLabel(user, users = []) {
  const name = user?.name || user?.full_name || user?.email || 'User';
  const sameName = users.filter((other) => {
    const otherName = other?.name || other?.full_name;
    return otherName && otherName === (user?.name || user?.full_name);
  });
  if (sameName.length > 1 && user?.email) {
    return `${name} (${user.email})`;
  }
  return name;
}
